/** Site-level prefs from sites/me (names align with API). */
export const DWB_SITE_PREFERENCE_NAMES = [
  'k5p_dwb_enabled',
  'msp_dwb_enabled',
  'hsp_dwb_enabled',
]

export const DWB_PREF_ELEM = 'k5p_dwb_enabled'
export const DWB_PREF_MS = 'msp_dwb_enabled'
export const DWB_PREF_HS = 'hsp_dwb_enabled'

function preferenceIsTrue(value) {
  return value === true || value === 'true'
}

function sitePreferenceIsTrue(site, prefName) {
  const pref = site?.preferences?.find(p => p.name === prefName)
  return preferenceIsTrue(pref?.value)
}

/** Site-level DWB prefs (elem / ms / hs); used for report access, not table columns. */
export function getDwbColumnEnabledFromSite(site) {
  return {
    elem: sitePreferenceIsTrue(site, DWB_PREF_ELEM),
    ms: sitePreferenceIsTrue(site, DWB_PREF_MS),
    hs: sitePreferenceIsTrue(site, DWB_PREF_HS),
  }
}

export function siteHasDwbTrainingProgram(site) {
  const { elem, ms, hs } = getDwbColumnEnabledFromSite(site)
  return elem || ms || hs
}
